<template>
  <pro-layout
    :menus="menus"
    :collapsed="collapsed"
    :mediaQuery="query"
    :isMobile="isMobile"
    :handleMediaQuery="handleMediaQuery"
    :handleCollapse="handleCollapse"
    :i18nRender="i18nRender"
    v-bind="settings"
  >
    <!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads paddingTop: fixedHeader ? '64px' : '0'
    -->
    <!-- <ads v-if="isProPreviewSite && !collapsed"/> -->
    <!-- Ads end -->
    <a-layout-content>
      <!-- <multi-tab v-if="multiTab"></multi-tab>
      <transition name="page-transition">
      </transition> -->
      <!-- <router-view v-if="isRouterAlive" /> -->
    </a-layout-content>
    <!-- 1.0.0+ 版本 pro-layout 提供 API，
          我们推荐使用这种方式进行 LOGO 和 title 自定义
    -->
    <template v-slot:menuRender>
      <side-menu
        :theme="settings.theme"
        :menuData="menus"
        :collapsed="collapsed"
        :collapsible="false"
        @toggleCollapse="toggleCollapse"
        :isMobile="isMobile"
      />
    </template>
    <template v-slot:collapsedButtonRender>
      <div class="none"></div>
    </template>
    <template v-slot:menuHeaderRender>
      <div :class="['logo',settings.theme]">
        <img v-if="!collapsed" src="@/assets/ls-img/logo.svg"/>
        <h1 class="color-00576d">MOM</h1>
      </div>
    </template>
    <!-- <setting-drawer :settings="settings" @change="handleSettingChange" /> -->
    <template v-slot:rightContentRender>
      <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
      <tabs-view class="tabs-view" @reload="reload" @close-tabs="closeMomTabs" />
      <!-- <global-footer /> -->
    </template>
    <!-- 无界时候应用 -->
    <tabs-view v-if="isWuJie" class="tabs-view" @reload="reload" @close-tabs="closeMomTabs" />
    <div class="custom-content">
      <router-view
        v-if="isRouterAlive"
        v-show="!isMomSubappRoute"
        ref="routerViewRef"
      />
      <mom-subapp-pool ref="momSubappPool" />
    </div>
    <!-- <template v-slot:footerRender>
      <global-footer />
    </template> -->
    <!-- <router-view v-if="isRouterAlive" /> -->
  </pro-layout>
</template>

<script>
// import { SettingDrawer, updateTheme } from '@ant-design-vue/pro-layout'  SettingDrawer是设置抽屉,如果有需要打开(生产环境不建议使用!)
import { updateTheme } from '@ant-design-vue/pro-layout'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { CONTENT_WIDTH_TYPE, SIDEBAR_TYPE, TOGGLE_MOBILE_TYPE } from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
// import GlobalFooter from '@/components/GlobalFooter'
import Ads from '@/components/Other/CarbonAds'
// import LogoSvg from '../assets/logo.svg?inline'
import LogUrl from '../assets/logo.png'
import tabsView from './modules/tabs-view'
import SideMenu from './menu/SideMenu.vue'
import MomSubappPool from '@/views/subapps/MomSubappPool'

export default {
  name: 'BasicLayout',
  components: {
    // SettingDrawer是设置抽屉,如果有需要打开(生产环境不建议使用!)
    // SettingDrawer,
    RightContent,
    // GlobalFooter,
    // LogoSvg,
    Ads,
    tabsView,
    SideMenu,
    MomSubappPool
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      LogUrl,
      // preview.pro.antdv.com only use.
      isProPreviewSite: process.env.VUE_APP_PREVIEW === 'true' && process.env.NODE_ENV !== 'development',
      // end

      // base
      menus: [],
      // 侧栏收起状态
      collapsed: false,
      title: defaultSettings.title,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        colorWeak: defaultSettings.colorWeak,
        hideHintAlert: false,
        hideCopyButton: false,
        breakpoint: false,
        siderWidth: 200
      },
      // 媒体查询
      query: {},

      // 是否手机模式
      isMobile: false
    }
  },
  computed: {
    isMomSubappRoute () {
      return Boolean(this.$route.meta && this.$route.meta.momSubapp)
    },
    isWuJie() {
      return !!window.__POWERED_BY_WUJIE__
    },
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.addRouters,
      cashHistory: (state) => state.pageHistory.cashHistory
    })
  },
  created () {
    const routes = this.mainMenu.find(item => item.path === '/')
    this.menus = (routes && routes.children) || []
    // 处理侧栏收起状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDEBAR_TYPE, this.collapsed)
    })
    this.$watch('isMobile', () => {
      this.$store.commit(TOGGLE_MOBILE_TYPE, this.isMobile)
    })
  },
  mounted () {
    // 使用无界,样式修改
    this.$nextTick(() => {
      if (this.isWuJie) {
        const domLogo = document.getElementsByClassName('ant-pro-sider-menu-logo')
        domLogo.forEach(item => {
          item.style.display = "none";
        });
        const domHeader = document.getElementsByClassName('ant-layout-header')
        domHeader.forEach(item => {
          item.style.display = "none";
        });
      }
    })

    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  methods: {
    i18nRender,
    handleMediaQuery (val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.isMobile = false
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.isMobile = true
        this.collapsed = false
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse (val) {
      this.collapsed = val
    },
    toggleCollapse () {
      this.collapsed = !this.$store.state.app.sideCollapsed;
    },
    handleSettingChange ({ type, value }) {
      type && (this.settings[type] = value)
      switch (type) {
        case 'contentWidth':
          this.settings[type] = value
          break
        case 'layout':
          if (value === 'sidemenu') {
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
          } else {
            this.settings.fixSiderbar = false
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
          }
          break
      }
    },
    closeMomTabs (fullPaths) {
      if (this.$refs.momSubappPool) {
        this.$refs.momSubappPool.close(fullPaths)
      }
    },
    reload (fullPath) {
      if (this.isMomSubappRoute) {
        if (this.$refs.momSubappPool) {
          this.$refs.momSubappPool.refresh(fullPath || this.$route.fullPath)
        }
        return
      }
      this.isRouterAlive = false
      // 刷新清掉当前页面缓存
      if (this.cashHistory && this.cashHistory[this.$route?.fullPath]) {
        delete this.cashHistory[this.$route?.fullPath]
      }
      setTimeout(() => {
        this.isRouterAlive = true
      }, 500)
      // this.$nextTick(function () {
      //   this.isRouterAlive = true
      // })
    }
  }
}
</script>

<style lang="less">
@import "./BasicLayout.less";
</style>
<style lang="less" scoped>
 /deep/.ant-pro-sider-menu-logo{
  margin-left:-24px;
  padding-left: 24px;
}
  .custom-content{
    height: calc(100vh - 56px);
    overflow: auto;
    padding: 8px 8px 0;
  }
  /deep/.ant-tabs-bar{
    margin: 8px 0 0 8px;
    border-bottom: 0;
  }
  .logo{
    height: 48px;
    position: relative;
    line-height: 48px;
    -webkit-transition: all .3s;
    transition: all .3s;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 8px #00000026;
    z-index: 13;
    text-align: center;
    padding: 10px 6px;
    h1{
      font-size: 14px;
      display: inline-block;
      line-height: 100%;
      width: 35px;
      margin-top: 10px;
      font-weight: 700;
      margin-left: 3px;
      vertical-align: top;
    }
    img{
      height: 25px;
      line-height: 48px;
      vertical-align: top;
      width: 122px;
    }
  }
  .color-00576d {
    color: #00576d !important
  }
</style>
